import { useTranslations } from 'next-intl';
import React from 'react';
import { AlertIcon } from '@mentimeter/ragnar-visuals';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

export const AutoplayNotification = () => {
  const t = useTranslations('presenting');
  return (
    <Box
      zIndex={5}
      position="absolute"
      top="20%"
      right="15%"
      maxWidth={500}
      flexDirection="row"
      alignItems="center"
      p="space6"
      borderRadius="4xl"
      bg="surfaceOverlayTransparent"
      extend={({ theme }) => ({
        backdropFilter: theme.kosmosBlur.xl,
        WebkitBackdropFilter: theme.kosmosBlur.xl,
      })}
    >
      <AlertIcon size={7} />
      <Text color="text" fontSize="125" ml="space3">
        {t('video_slide_autoplay_blocked_message')}
      </Text>
    </Box>
  );
};
